import { useState, useMemo } from "react";
import { get, isEmpty } from "lodash";

const useGlobalSearch = ({ data, searchable, isRemote }) => {
  const [search, setSearch] = useState("");

  const searchedData = useMemo(() => {
    let result = data;

    if (!isRemote && !isEmpty(searchable) && search) {
      result = data.filter((item) =>
        searchable.some((key) =>
          get(item, key, "").toLowerCase().includes(search.toLowerCase())
        )
      );
    }

    return result;
  }, [data, searchable, isRemote, search]);

  return {
    search,
    setSearch,
    searchedData,
  };
};

export default useGlobalSearch;
